'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactSalesButtonPropsInterface = undefined;

var _react = require('react');

var ContactSalesButtonPropsInterface = exports.ContactSalesButtonPropsInterface = {
  allowModal: _react.PropTypes.bool,
  contactIsc: _react.PropTypes.bool,
  termId: _react.PropTypes.number,
  additionalUnitQuantity: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/contactSales/ContactSalesPropsInterface.js
// module id = 343
// module chunks = 3 4 5